export default "__VITE_ASSET__2645e204__"